export default __webpack_public_path__ + "static/sam42_engineering-d6516fbb41548693501aad9fab000024.jpg";